module.exports = __webpack_public_path__ + "static/media/venetian01.7dd90beb.png";